module.exports = __webpack_public_path__ + "img/archiv_icon.a03e3019.svg";